export const ADD_SPOT_ERROR = 'ADD_SPOT_ERROR';
export const ADD_SPOT_LOADING = 'ADD_SPOT_LOADING';
export const ADD_SPOT_SUCCESS = 'ADD_SPOT_SUCCESS';

export const UPDATE_SPOT_ERROR = 'UPDATE_SPOT_ERROR';
export const UPDATE_SPOT_LOADING = 'UPDATE_SPOT_LOADING';
export const UPDATE_SPOT_SUCCESS = 'UPDATE_SPOT_SUCCESS';

export const FETCH_SPOT_ERROR = 'FETCH_SPOT_ERROR';
export const FETCH_SPOT_LOADING = 'FETCH_SPOT_LOADING';
export const FETCH_SPOT_SUCCESS = 'FETCH_SPOT_SUCCESS';

export const FETCH_BY_ID_SPOT_ERROR = 'FETCH_BY_ID_SPOT_ERROR';
export const FETCH_BY_ID_SPOT_LOADING = 'FETCH_BY_ID_SPOT_LOADING';
export const FETCH_BY_ID_SPOT_SUCCESS = 'FETCH_BY_ID_SPOT_SUCCESS';

export const DELETE_SPOT_ERROR = 'DELETE_SPOT_ERROR';
export const DELETE_SPOT_LOADING = 'DELETE_SPOT_LOADING';
export const DELETE_SPOT_SUCCESS = 'DELETE_SPOT_SUCCESS';

export const DELETE_SPOT_FAILURE = 'DELETE_SPOT_FAILURE';
export const FETCH_SPOT_FAILURE = 'FETCH_SPOT_FAILURE';
export const UPDATE_SPOT_FAILURE = 'UPDATE_SPOT_FAILURE';
